import { ITenant } from 'app/shared/model/tenant.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface ITinymedicPatientOrder {
  id?: string;
  status?: keyof typeof OrderStatus;
  orderType?: keyof typeof EntityType;
  createdById?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  tenant?: ITenant | null;
  patient?: IGlucoUser | null;
  deliveryAddress?: IContactDetails | null;
}

export const defaultValue: Readonly<ITinymedicPatientOrder> = {
  active: false,
};
